import { MySigner, getContract } from "../hooks/getContract";
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import { useLocation } from "react-router-dom";
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { ethers } from "ethers";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAccount } from "wagmi";


export default function Detail() {

    const { address, isConnected } = useAccount()

    // For Mint Model
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [Auction, setAuction] = useState([])
    const [Aid, setAid] = useState()


    const test = isConnected ? MySigner : null
    const AuctionContract = getContract(test)
    const location = useLocation()

    async function Data() {
        try {
            const AuctionData = await AuctionContract.auctions(Aid)

            setAuction(AuctionData)
        } catch (error) {
            console.log(error);
        }
    }
    console.log(Auction);

    async function MakeBid(e) {
        e.preventDefault();
        if (address) {
            try {
                const Amount = e.target.amount.value
                const Bid = await AuctionContract.placeBid(Aid, { value: ethers.utils.parseEther(Amount) })

                await toast.promise(Bid.wait(), {
                    pending: 'Placing Bid...',
                    success: 'Successfully Placed',
                    error: 'Failed',
                });
                Data()
            } catch (error) {
                console.log(error);
                toast.error(error.reason ? error.reason : error.data ? error.data.message : error.message)
            }
        } else {
            toast.info("Connect Wallet")
        }


    }

    async function SaleEnd() {
        try {

            const End = await AuctionContract.endAuction(Aid)
            await toast.promise(End.wait(), {
                pending: 'Claim...',
                success: 'Successfully Claim',
                error: 'Failed',
            });
        } catch (error) {
            toast.error(error.reason ? error.reason : error.data ? error.data.message : error.message)
            console.log(error);
        }
    }


    useEffect(() => {
        const url = new URLSearchParams(location.search)
        const Auctionid = url.get('id')
        console.log(Auctionid);
        setAid(Auctionid)
    }, [])

    useEffect(() => {
        if (Aid) {
            Data()
        }
    }, [Aid])


    return (
        <>
            <div className="flex min-h-screen w-full flex-col overflow-hidden">
                <ToastContainer
                    position="bottom-right"
                />
                <div className="container mx-auto py-8">
                    <div className="flex flex-col gap-8 px-4 lg:flex-row">
                        <div className="basis-2/5">
                            <div className="mx-auto overflow-hidden rounded-lg border-2 border-gray-300 md:w-3/5 lg:w-4/5">
                                <div className="flex justify-between py-2 px-3 text-sm text-slate-500">
                                    <div className="h-[400px] animate-pulse bg-slate-300" />
                                    <div
                                        className="h-[400px] w-full "
                                    >
                                        <img src={Auction?.Img} />
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="basis-3/5 ">
                                <p className="cursor-pointer font-bold" style={{ color: '#c53de5', fontSize: '20px', borderBottom: '2px solid #c53de5', width: 'fit-content' }}>
                                    NFT
                                </p>

                                {Auction?.auctionEndTime &&
                                    <div className="pt-6 text-md text-slate-400">

                                        {(parseInt(Auction?.auctionEndTime) < Math.floor(Date.now() / 1000)) && "Sale ended" ||
                                            <>
                                                Sale Ends: <Countdown date={parseInt(Auction?.auctionEndTime) * 1000} />
                                            </>
                                        }

                                    </div>}
                                <div className="mt-8 overflow-hidden" style={{ border: '1px solid #443f3f' }}>
                                    <div className="py-2 px-4 backdrop-blur-md" style={{ backgroundColor: '#44434140', color: 'white' }}>
                                        <p>Current Highest Bid</p>
                                        {Auction?.highestBid && ethers.utils.formatEther(Auction?.highestBid)} MATIC
                                        <div className="flex items-center gap-2 py-4 text-3xl">
                                            <span className="self-end text-base text-white">
                                                Listing Price
                                                <br />
                                                {Auction?.basePrice && ethers.utils.formatEther(Auction?.basePrice)} MATIC
                                            </span>
                                        </div>
                                        <p className="">
                                        </p>
                                        <div className="flex py-4">
                                            {(parseInt(Auction?.auctionEndTime) < Math.floor(Date.now() / 1000)) && <>
                                                {(Auction?.seller == address || Auction?.highestBidder == address) &&
                                                    <button
                                                        className="basis-full rounded-x p-4 text-white hover:opacity-80 sm:basis-1/2"
                                                        style={{ backgroundColor: '#70357e' }}
                                                        onClick={SaleEnd}
                                                        disabled={Auction?.ended == true ? true : false}

                                                    >
                                                        Claim
                                                        {/* {Auction?.seller == address ? 'Claim':''}
                                                    {Auction?.highestBidder == address?'Claim':''} */}
                                                    </button>}
                                            </>
                                                || <button
                                                    className="basis-full rounded-x p-4 text-white hover:opacity-80 sm:basis-1/2"
                                                    style={{ backgroundColor: '#70357e' }}
                                                    onClick={handleOpen}
                                                >
                                                    Make offer
                                                </button>
                                            }

                                            <Modal
                                                open={open}
                                                onClose={handleClose}
                                                aria-labelledby="modal-modal-title"
                                                aria-describedby="modal-modal-description"
                                            >
                                                <div className="login-box">
                                                    <div className="closein" onClick={handleClose}>
                                                        <CloseIcon style={{ color: 'white' }} />
                                                    </div>
                                                    <br />
                                                    <form onSubmit={MakeBid}>
                                                        <div className="user-box">
                                                            <input type="text" name="amount" required="" />
                                                            <label>Enter Amount</label>
                                                        </div>

                                                        <center>
                                                            <button type="submit">
                                                                Make offer
                                                                <span />
                                                            </button>
                                                        </center>
                                                    </form>
                                                </div>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
}